import React from 'react'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import { resetPassword } from 'ducks/auth'
import { useControlledForm } from 'hooks'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

const useResetPasswordMutations = () => {
  const dispatch = useDispatch()

  const handleResetPassword = React.useCallback(
    ({ email }) => {
      dispatch(resetPassword(email))
    },
    [dispatch],
  )

  return { handleResetPassword }
}

export const useResetPasswordForm = () => {
  const defaultValues = getDefaultValues()
  const schema = getSchema()

  const { handleResetPassword } = useResetPasswordMutations()

  const handleFormData = React.useCallback(
    data => {
      handleResetPassword({ ...data })
    },
    [handleResetPassword],
  )

  const { control, formState, handleFormSubmit } = useControlledForm({
    defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  return {
    state: { control, formState },
    handlers: { handleFormSubmit },
  }
}
